import React from 'react';
import { motion } from 'framer-motion';

const ChaptersHero = () => (
  <section className="relative min-h-[45vh] flex items-center pt-28 pb-16 overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-brand-surfaceLight via-brand-dark to-black"></div>
    <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
      <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="text-brand-accent font-semibold tracking-widest uppercase text-sm mb-4">
        The Journey
      </motion.p>
      <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}
        className="text-4xl md:text-6xl font-display font-bold text-white mb-6 text-glow">
        A Chronicle of Ascension
      </motion.h1>
      <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}
        className="text-xl text-gray-400 max-w-2xl mx-auto">
        Eleven chapters. Eleven worlds. Five centuries of human ambition, grief, and wonder.
      </motion.p>
    </div>
  </section>
);

export default ChaptersHero;